import { createSlice } from "@reduxjs/toolkit";

const data = {
    entity: {
        idTrabajador: 0,
        idPersona: 0,
        idFilial: 0,
        persona: "",
        tipoDocumento: "",
        numeroDocumento: "",
        fechaIngreso: null,
        idCargo: 0,
        seudonimo: "",
        idEstado: 2,
    },
    listCargo: [],
    validationActive: {
        idPersona: false,
        idCargo: false,
    },
    validationMessage: [],
}

export const trabajadorSlice = createSlice({
    name: "trabajador",
    initialState: {},
    reducers: {
        init: (state, action) => {
            const { sliceKey } = action.payload;
            if (!state[sliceKey]) state[sliceKey] = JSON.parse(JSON.stringify(data));
        },
        setEntity: (state, action) => {
            const { sliceKey, data } = action.payload;
            state[sliceKey].entity = data;
        },
        setData: (state, action) => {
            const { sliceKey, name, value } = action.payload;

            // Los campos que empiezan con "id" se guardan como entero. No se puede
            // reasignar value (es const): se calcula en otra variable.
            const nuevoValor = name.startsWith("id") ? parseInt(value) : value;

            state[sliceKey].entity[name] = nuevoValor
            state[sliceKey].validationActive[name] = true
        },
        setListCargo: (state, action) => {
            const { sliceKey, data } = action.payload;
            state[sliceKey].listCargo = data;
        },
        setValidationMessage: (state, action) => {
            const { sliceKey, message } = action.payload;
            state[sliceKey].validationMessage = message;
        },
        activeValidations: (state, action) => {
            const { sliceKey } = action.payload;
            Object.keys(state[sliceKey].validationActive).forEach(function (key) {
                state[sliceKey].validationActive[key] = true;
            })
        },
    },
});

export const { init, setEntity, setData, setListCargo, setValidationMessage, activeValidations } = trabajadorSlice.actions;
export const defaultTrabajador = { ...data.entity };
export default trabajadorSlice.reducer;